import React from 'react';
import Decimal from 'decimal.js';
import { Typography } from 'seagull/components/Typography';
import { pluralizeUnitName } from "../../../../../utils/unit-name.utils";
import { isSuitableForTimeActivities } from "../../../../../models/service/selectors";
const UnbilledTimeActivities = _ref => {
  let {
    service,
    TIME_ACTIVITIES,
    serviceTimeActivitiesLength
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, TIME_ACTIVITIES && !!serviceTimeActivitiesLength && isSuitableForTimeActivities(service) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "unbilled-time-activities",
    variant: "paragraph2",
    skin: "success"
  }, "".concat(pluralizeUnitName(new Decimal(serviceTimeActivitiesLength), 'unbilled activity', true))));
};
export default UnbilledTimeActivities;